import Controller from "./lost.controller";
import template from "./lost.html";

const lost = {
  template,
  controller: Controller,
};

export default lost;



// WEBPACK FOOTER //
// ./src/pages/lost/lost.component.js